export default "__VITE_ASSET__DRtTHNJ9__"